import { PdfTable } from './pdf-table';
import { PdfColDef } from './pdf-col-def';
import { PdfCellType } from './pdf-cell-type.enum';

const pdfDocStyles = require('./pdf-doc-styles.json');

export class PdfDoc {

    pageOrientation: string;
    content: any[];
    footer: any;
    styles: any;

    constructor() {
        this.pageOrientation = 'landscape';
        this.content = [];
        this.footer = this.buildFooter();
        this.styles = pdfDocStyles;
    }

    addTableHeader(data: string[][]) {
        this.content.push(this.addHeaderTable(data, 6));
    }

    addLineBreak() {
        this.content.push({ text: ' ' });
    }

    addCard(cardTitle: string, pdfColDefs: PdfColDef[], data: string[][], hasHeaders: boolean, lineNumbers?: number[]) {
        this.content.push({ text: cardTitle, style: 'cardTitle' });
        this.content.push({ text: ' ' });
        this.content.push(this.addTable(pdfColDefs, data, hasHeaders, lineNumbers));
    }

    addHeaderTable(data: string[][], columnCount: number) {
        let pdfColDefs: PdfColDef[] = [];
        for (let i = 0; i < columnCount; i++) {
            pdfColDefs.push(new PdfColDef(undefined, PdfCellType.HEADER, '*'));
        }
        return {
            'layout': {
                hLineWidth: function(i) { return (i === 2) ? 2 : 0; },
                vLineWidth: function() { return 0; },
                hLineColor: function() { return 'black'; },
                vLineColor: function() { return 'black'; }
            },
            'table': new PdfTable(pdfColDefs, data)
        };
    }

    addTable(pdfColDefs: PdfColDef[], data: string[][], hasHeaders: boolean, lineNumbers?: number[]) {
        return {
            'layout': this.getTableLayout(hasHeaders, lineNumbers),
            'table': new PdfTable(pdfColDefs, data)
        };
    }

    getTableLayout(hasHeaders: boolean, lineNumbers?: number[]) {
        return {
            hLineWidth: this.getHLineWidth(2, 1, hasHeaders, lineNumbers),
            vLineWidth: this.getVLineWidth(2, 0),
            hLineColor: this.getHLineColor('black', 'gray'),
            vLineColor: this.getVLineColor('black', 'gray')
        };
    }

    getHLineWidth(horizontalBorderWidth, innerHorizontalLinesWidth, hasHeaders: boolean, innerHorizontalLineNumbers?: number[]) {
        return function (i, node) {
            if (i === 0 || i === node.table.body.length) { // Table borders
                return horizontalBorderWidth;
            } else if (i === 1 && hasHeaders) { // Header bottom line
                return horizontalBorderWidth;
            } else if (!innerHorizontalLineNumbers || innerHorizontalLineNumbers.indexOf(i) >= 0) { // Inner lines (data section)
                return innerHorizontalLinesWidth;
            } else {
                return 0;
            }
        };
    }

    getVLineWidth(verticalBorderWidth, innerVerticalLinesWidth) {
        return function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? verticalBorderWidth : innerVerticalLinesWidth;
        };
    }

    getHLineColor(horizontalBorderColor, innerHorizontalLinesColor) {
        return function (i, node) {
            return (i === 0 || i === node.table.body.length) ? horizontalBorderColor : innerHorizontalLinesColor;
        };
    }

    getVLineColor(verticalBorderColor, innerVerticalLinesColor) {
        return function (i, node) {
            return (i === 0 || i === node.table.widths.length) ? verticalBorderColor : innerVerticalLinesColor;
        };
    }

    buildFooter() {
        return function (currentPage, pageCount) {
            return {
                text: currentPage.toString() + ' / ' + pageCount,
                alignment: 'right',
                style: 'pageNumberFooter',
                margin: [0, 20, 20, 0]
            };
        };
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pdf/pdf-doc.ts